// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 3840px) {
  
  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  body{
    /* background-image: url('./assets/lightbackground.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed; */
    background:white;
    font-family: "Kanit", sans-serif !important;
  }

  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  .react-datepicker__year-select{
    border:none;
    font-size: 16px;
    font-weight: 300;
    padding: 3px 0px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .react-datepicker__month-select{
    border:none;
    font-size: 16px;
    font-weight: 300;
  }

  .main-layout{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
  }

  .triangle-layout{
    display:flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
  }

  .triangle-background{
    position: absolute;
    top: 10px;
    width: 250px;
  }

  .triangle-data-container{
    display:flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
  }

  .triangle-data-container h1{
    margin-bottom: 0px;
    font-size: 40px;
  }

  .triangle-first-line{
    display:flex;
  }

  .triangle-first-left{
    display:flex;
    margin-right: 10px;
  }

  .triangle-first-right{
    display:flex;
    margin-left: 10px;
  }

  .triangle-second-line{
    display:flex;
    margin-top: 15px;
  }

  .triangle-second-left{
    margin-right: 15px;
  }

  .triangle-seven-number{
    font-size: 40px;
    color: white !important;
    margin-top: 16px;
    margin-bottom: 0px;
  }

  .triangle-second-right{
    margin-left: 15px;
  }

  .triangle-third-line{
    display:flex;
    transform:translateY(-10px);
  }

  .triangle-third-left{
    margin-right: 50px;
    display:flex;
  }

  .triangle-third-right{
    margin-left: 50px;
    display:flex;
  }

  .triangle-forth-line{
    display: flex;
    transform:translateY(-10px);
  }

  .triangle-number-forth-left{
    margin-right: 40px;
  }

  .triangle-number-forth-right{
    margin-left: 40px;
  }

  .triangle-fift-line{
    transform: translateY(-10px);
  }

  .triangle-number{
    margin: 0px 10px;
  }

  .main-content-container{
    padding-top: 120px;
    padding-left: 15vw;
    padding-right: 15vw;
    position: relative;
    z-index: 1;
  }

  .page-content-container{
    padding-top: 80px;
    padding-left: 10px;
    padding-right: 10px;
    display:flex;
    flex-direction: column;
    align-items: center;
    min-height: 85vh;
  }

  .page-content-container h1, h2, h3{
    color: #022452 !important;
  }

  .background-element{
    padding-bottom: 0px;
  }

  .carousel-root {
    overflow: visible;
    background: none;
    width: 100%;
    z-index: 1;
    margin-bottom: 5px;
  }

  .carousel.carousel-slider{
    overflow: visible !important;
  }

  .carousel .slider-wrapper{
    border-radius: 10px;
  }

  .carousel .slide {
    z-index: 1;
  }

  .carousel .control-dots{
    bottom: -35px !important;
  }

  .dot{
    background: #FFBD59 !important;
  }

  .modal-overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7); /* Dark semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content{
    background-color: #FFBD59 !important;
    transform: translateY(20%);
  }

  .modal-header{
    background-color: #022452 !important;
    color: white;
  }

  .btn-secondary{
    background-color: #022452 !important;
    color: white;
  }

  .btn-danger.active{
    background-color: #022452 !important;
    border: solid 1px #FFBD59;
    box-shadow: 0px 0px 4px black;
  }

  .form-container{
    width: 50%;
    min-width: 500px;
  }

  .error-message{
    color:red !important;
    font-size: 30px;
    text-shadow: 0px 0px 1px black;
  }
}

@media screen and (max-width: 540px) {
  .App {
    text-align: center;
  }

  .App-logo {
    height: 40vmin;
    pointer-events: none;
  }

  body{
    /* background-image: url('./assets/lightbackground.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed; */
    background:white;
    font-family: "Kanit", sans-serif !important;
  }

  .App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
  }

  .App-link {
    color: #61dafb;
  }

  .react-datepicker__year-select{
    border:none;
    font-size: 16px;
    font-weight: 300;
    padding: 3px 0px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .react-datepicker__month-select{
    border:none;
    font-size: 16px;
    font-weight: 300;
  }

  .main-layout{
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
  }

  .triangle-layout{
    display:flex;
    position: relative;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 20px;
  }

  .triangle-background{
    position: absolute;
    top: 10px;
  }

  .triangle-data-container{
    display:flex;
    flex-direction: column;
    align-items: center;
    z-index: 2;
  }

  .triangle-data-container h1{
    margin-bottom: 0px;
  }

  .triangle-first-line{
    display:flex;
  }

  .triangle-first-left{
    display:flex;
    margin-right: 8px;
  }

  .triangle-first-right{
    display:flex;
    margin-left: 8px;
  }

  .triangle-second-line{
    display:flex;
    margin-top: 15px;
  }

  .triangle-second-left{
    margin-right: 15px;
  }

  .triangle-second-right{
    margin-left: 15px;
  }

  .triangle-third-line{
    display:flex;
    transform:translateY(-10px);
  }

  .triangle-third-left{
    margin-right: 30px;
    display:flex;
  }

  .triangle-third-right{
    margin-left: 30px;
    display:flex;
  }

  .triangle-forth-line{
    display: flex;
    transform:translateY(-10px);
  }

  .triangle-number-forth-left{
    margin-right: 25px;
  }

  .triangle-number-forth-right{
    margin-left: 25px;
  }

  .triangle-fift-line{
    transform: translateY(-10px);
  }

  .triangle-number{
    margin: 0px 10px;
  }

  .main-content-container{
    padding-top: 80px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative;
    z-index: 1;
  }

  .page-content-container{
    padding-top: 80px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 80px;
    display:flex;
    flex-direction: column;
    align-items: center;
    min-height: auto;
  }

  .background-element{
    padding-bottom: 80px;
  }

  .carousel-root {
    overflow: visible;
    background: none;
    width: 100%;
    z-index: 1;
    margin-bottom: 5px;
  }

  .carousel.carousel-slider{
    overflow: visible !important;
  }

  .carousel .slider-wrapper{
    border-radius: 10px;
  }

  .carousel .slide {
    z-index: 1;
  }

  .carousel .control-dots{
    bottom: -35px !important;
  }

  .dot{
    background: #FFBD59 !important;
  }

  .modal-overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7); /* Dark semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content{
    background-color: #FFBD59 !important;
    transform: translateY(20%);
  }

  .modal-header{
    background-color: #022452 !important;
    color: white;
  }

  .btn-secondary{
    background-color: #022452 !important;
    color: white;
  }

  .btn-danger.active{
    background-color: #022452 !important;
    border: solid 1px #FFBD59;
    box-shadow: 0px 0px 4px black;
  }

  .form-container{
    width: 90%;
    min-width: 0;
  }

  .page-text{
    font-size: 22px;
    margin-top: 20px;
  }

  .error-message{
    color:red !important;
    text-shadow: 0px 0px 1px black;
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE;;;mCAG+B;IAC/B,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,qCAAqC;IAC3E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE;;;mCAG+B;IAC/B,gBAAgB;IAChB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,qCAAqC;IAC3E,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,YAAY;EACd;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;EACjB;AACF","sourcesContent":["@media screen and (max-width: 3840px) {\n  \n  .App {\n    text-align: center;\n  }\n\n  .App-logo {\n    height: 40vmin;\n    pointer-events: none;\n  }\n\n  body{\n    /* background-image: url('./assets/lightbackground.jpg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-attachment: fixed; */\n    background:white;\n    font-family: \"Kanit\", sans-serif !important;\n  }\n\n  .App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n\n  .App-link {\n    color: #61dafb;\n  }\n\n  .react-datepicker__year-select{\n    border:none;\n    font-size: 16px;\n    font-weight: 300;\n    padding: 3px 0px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  .react-datepicker__month-select{\n    border:none;\n    font-size: 16px;\n    font-weight: 300;\n  }\n\n  .main-layout{\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 20px;\n  }\n\n  .triangle-layout{\n    display:flex;\n    position: relative;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 20px;\n  }\n\n  .triangle-background{\n    position: absolute;\n    top: 10px;\n    width: 250px;\n  }\n\n  .triangle-data-container{\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .triangle-data-container h1{\n    margin-bottom: 0px;\n    font-size: 40px;\n  }\n\n  .triangle-first-line{\n    display:flex;\n  }\n\n  .triangle-first-left{\n    display:flex;\n    margin-right: 10px;\n  }\n\n  .triangle-first-right{\n    display:flex;\n    margin-left: 10px;\n  }\n\n  .triangle-second-line{\n    display:flex;\n    margin-top: 15px;\n  }\n\n  .triangle-second-left{\n    margin-right: 15px;\n  }\n\n  .triangle-seven-number{\n    font-size: 40px;\n    color: white !important;\n    margin-top: 16px;\n    margin-bottom: 0px;\n  }\n\n  .triangle-second-right{\n    margin-left: 15px;\n  }\n\n  .triangle-third-line{\n    display:flex;\n    transform:translateY(-10px);\n  }\n\n  .triangle-third-left{\n    margin-right: 50px;\n    display:flex;\n  }\n\n  .triangle-third-right{\n    margin-left: 50px;\n    display:flex;\n  }\n\n  .triangle-forth-line{\n    display: flex;\n    transform:translateY(-10px);\n  }\n\n  .triangle-number-forth-left{\n    margin-right: 40px;\n  }\n\n  .triangle-number-forth-right{\n    margin-left: 40px;\n  }\n\n  .triangle-fift-line{\n    transform: translateY(-10px);\n  }\n\n  .triangle-number{\n    margin: 0px 10px;\n  }\n\n  .main-content-container{\n    padding-top: 120px;\n    padding-left: 15vw;\n    padding-right: 15vw;\n    position: relative;\n    z-index: 1;\n  }\n\n  .page-content-container{\n    padding-top: 80px;\n    padding-left: 10px;\n    padding-right: 10px;\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: 85vh;\n  }\n\n  .page-content-container h1, h2, h3{\n    color: #022452 !important;\n  }\n\n  .background-element{\n    padding-bottom: 0px;\n  }\n\n  .carousel-root {\n    overflow: visible;\n    background: none;\n    width: 100%;\n    z-index: 1;\n    margin-bottom: 5px;\n  }\n\n  .carousel.carousel-slider{\n    overflow: visible !important;\n  }\n\n  .carousel .slider-wrapper{\n    border-radius: 10px;\n  }\n\n  .carousel .slide {\n    z-index: 1;\n  }\n\n  .carousel .control-dots{\n    bottom: -35px !important;\n  }\n\n  .dot{\n    background: #FFBD59 !important;\n  }\n\n  .modal-overlay{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7); /* Dark semi-transparent background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .modal-content{\n    background-color: #FFBD59 !important;\n    transform: translateY(20%);\n  }\n\n  .modal-header{\n    background-color: #022452 !important;\n    color: white;\n  }\n\n  .btn-secondary{\n    background-color: #022452 !important;\n    color: white;\n  }\n\n  .btn-danger.active{\n    background-color: #022452 !important;\n    border: solid 1px #FFBD59;\n    box-shadow: 0px 0px 4px black;\n  }\n\n  .form-container{\n    width: 50%;\n    min-width: 500px;\n  }\n\n  .error-message{\n    color:red !important;\n    font-size: 30px;\n    text-shadow: 0px 0px 1px black;\n  }\n}\n\n@media screen and (max-width: 540px) {\n  .App {\n    text-align: center;\n  }\n\n  .App-logo {\n    height: 40vmin;\n    pointer-events: none;\n  }\n\n  body{\n    /* background-image: url('./assets/lightbackground.jpg');\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-attachment: fixed; */\n    background:white;\n    font-family: \"Kanit\", sans-serif !important;\n  }\n\n  .App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n  }\n\n  .App-link {\n    color: #61dafb;\n  }\n\n  .react-datepicker__year-select{\n    border:none;\n    font-size: 16px;\n    font-weight: 300;\n    padding: 3px 0px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n\n  .react-datepicker__month-select{\n    border:none;\n    font-size: 16px;\n    font-weight: 300;\n  }\n\n  .main-layout{\n    display:flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 20px;\n  }\n\n  .triangle-layout{\n    display:flex;\n    position: relative;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n    padding: 20px;\n  }\n\n  .triangle-background{\n    position: absolute;\n    top: 10px;\n  }\n\n  .triangle-data-container{\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: 2;\n  }\n\n  .triangle-data-container h1{\n    margin-bottom: 0px;\n  }\n\n  .triangle-first-line{\n    display:flex;\n  }\n\n  .triangle-first-left{\n    display:flex;\n    margin-right: 8px;\n  }\n\n  .triangle-first-right{\n    display:flex;\n    margin-left: 8px;\n  }\n\n  .triangle-second-line{\n    display:flex;\n    margin-top: 15px;\n  }\n\n  .triangle-second-left{\n    margin-right: 15px;\n  }\n\n  .triangle-second-right{\n    margin-left: 15px;\n  }\n\n  .triangle-third-line{\n    display:flex;\n    transform:translateY(-10px);\n  }\n\n  .triangle-third-left{\n    margin-right: 30px;\n    display:flex;\n  }\n\n  .triangle-third-right{\n    margin-left: 30px;\n    display:flex;\n  }\n\n  .triangle-forth-line{\n    display: flex;\n    transform:translateY(-10px);\n  }\n\n  .triangle-number-forth-left{\n    margin-right: 25px;\n  }\n\n  .triangle-number-forth-right{\n    margin-left: 25px;\n  }\n\n  .triangle-fift-line{\n    transform: translateY(-10px);\n  }\n\n  .triangle-number{\n    margin: 0px 10px;\n  }\n\n  .main-content-container{\n    padding-top: 80px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: relative;\n    z-index: 1;\n  }\n\n  .page-content-container{\n    padding-top: 80px;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-bottom: 80px;\n    display:flex;\n    flex-direction: column;\n    align-items: center;\n    min-height: auto;\n  }\n\n  .background-element{\n    padding-bottom: 80px;\n  }\n\n  .carousel-root {\n    overflow: visible;\n    background: none;\n    width: 100%;\n    z-index: 1;\n    margin-bottom: 5px;\n  }\n\n  .carousel.carousel-slider{\n    overflow: visible !important;\n  }\n\n  .carousel .slider-wrapper{\n    border-radius: 10px;\n  }\n\n  .carousel .slide {\n    z-index: 1;\n  }\n\n  .carousel .control-dots{\n    bottom: -35px !important;\n  }\n\n  .dot{\n    background: #FFBD59 !important;\n  }\n\n  .modal-overlay{\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7); /* Dark semi-transparent background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n\n  .modal-content{\n    background-color: #FFBD59 !important;\n    transform: translateY(20%);\n  }\n\n  .modal-header{\n    background-color: #022452 !important;\n    color: white;\n  }\n\n  .btn-secondary{\n    background-color: #022452 !important;\n    color: white;\n  }\n\n  .btn-danger.active{\n    background-color: #022452 !important;\n    border: solid 1px #FFBD59;\n    box-shadow: 0px 0px 4px black;\n  }\n\n  .form-container{\n    width: 90%;\n    min-width: 0;\n  }\n\n  .page-text{\n    font-size: 22px;\n    margin-top: 20px;\n  }\n\n  .error-message{\n    color:red !important;\n    text-shadow: 0px 0px 1px black;\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
